<template>
  <div>
    <div class="inputCard">
      <header class="pointer" @click="toggleAccordion()" :style="accordion.services ? '' : 'border-radius:5px 5px 5px 5px'"><i class="mr-2 fa w3-small" :class="accordion.services ? 'fa-chevron-down' : 'fa-chevron-right'"></i>Home Page Services</header>
      <div class="content" v-if="accordion.services">
        <div class="input-row-2 w3-padding-8">
          <label>Enabled</label>
          <div class="w3-right-align">
            <label class="switch">
              <input type="checkbox" v-model="state.siteData.pages.home.sections.services.enabled">
              <span class="slider"></span>
            </label>
          </div>
        </div>
        <template v-if="state.siteData.pages.home.sections.services.enabled">
          <div class="cardRow w3-padding-8">
            <label>Services Type</label>
            <select class="w3-select w3-border" v-model="state.siteData.pages.home.sections.services.type">
              <option value="style1">Images</option>
              <option value="style2">Icons</option>
              <!-- <option value="style3">Style 3</option> -->
            </select>
          </div>

          <!-- Images -->
          <template v-if="state.siteData.pages.home.sections.services.type === 'style1'">
            <div class="cardRow w3-padding-8 w3-border-bottom" style="margin-bottom:0;">
              <label class="w3-label">Title</label>
              <input v-model="state.siteData.pages.home.sections.services.style1.title" class="w3-input w3-border" />
            </div>
            <div class="cardRow w3-padding-8 w3-border-bottom" style="margin-bottom:0;">
              <label class="w3-label">Subtitle</label>
              <input v-model="state.siteData.pages.home.sections.services.style1.subtitle" class="w3-input w3-border" />
            </div>
            <div class="cardRow w3-padding-8 w3-border-bottom" style="margin-bottom:0;">
              <label class="w3-label">Margin Top</label>
              <input v-model="state.siteData.pages.home.sections.services.style1.margintop" class="w3-input w3-border" />
            </div>
            <div class="cardRow w3-padding-8 w3-border-bottom" style="margin-bottom:0;">
              <label class="w3-label">Top Divider?</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="state.siteData.pages.home.sections.services.divider">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <div class="cardRow w3-padding-8 w3-border-bottom" style="margin-bottom:0;">
              <label class="w3-label">Header Divider?</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="state.siteData.pages.home.sections.services.style1.titleDivider">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
          </template>
          <!-- Icons -->
          <template v-if="state.siteData.pages.home.sections.services.type === 'style2'">
            <div class="cardRow w3-padding-8 w3-border-bottom" style="margin-bottom:0;">
              <label class="w3-label">Title</label>
              <input v-model="state.siteData.pages.home.sections.services.style2.title" class="w3-input w3-border" />
            </div>
            <div class="cardRow w3-padding-8 w3-border-bottom" style="margin-bottom:0;">
              <label class="w3-label">Subtitle</label>
              <input v-model="state.siteData.pages.home.sections.services.style2.subtitle" class="w3-input w3-border" />
            </div>
            <div class="input-row w3-padding-8">
              <div>
                <div class="featureStyle1SettingsGrid outline w3-padding w3-white w3-margin-bottom" v-for="(service, key, index) in state.siteData.pages.home.sections.services.style2.items" :key="index">
                  <div>
                    <label for="icon1" class="w3-label">Icon</label>
                    <div class="w3-black" style="height:100px; width:100px; display: flex; justify-content: center; align-items: center;" @click="setIcon('pages.home.sections.features.style3.items.' + key + '.icon')">
                      <i style="font-size: 44px;" :class="'fa fa-' + state.siteData.pages.home.sections.features.style3.items[key].icon" :title="state.siteData.pages.home.sections.features.style3.items[key].icon"></i>
                    </div>
                  </div>
                  <div>
                    <div class="w3-row">
                      <label for="title1" class="w3-label">Title</label>
                      <input name="title1" v-model="state.siteData.pages.home.sections.features.style3.items[key].title" placeholder="Title" class="w3-input w3-border" />
                    </div>
                    <div class="w3-row w3-margin-bottom">
                      <label for="text1" class="w3-label">Text</label>
                      <input name="text1" v-model="state.siteData.pages.home.sections.features.style3.items[key].text" placeholder="placeholder text" class="w3-input w3-border" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
var dataStore = require('@/dataStore').default

export default {
  name: 'cmshomeservices',
  data() {
    return {
      state: dataStore.state
    }
  },
  props: {
    accordion: Object
  },
  components: {
    'tinymce-editor': Editor
  },
  methods: {
    toggleAccordion() {
      this.$emit('toggleAccordion', !this.accordion.services)
    },
    setIcon(which) {
      this.state.modals.iconModal = true
      this.state.selectedIcon = which
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/cms/pages/home/cmsHomeServices.vue